/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "link",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#367C2B"
            },
            "link": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "23.8",
            "height": "23.9"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 23.8 23.9", className: "link", width: this.props.width, height: this.props.height, style: this.props.link },
            _react2["default"].createElement("path", { className: "st0", d: "M8.2 15.6c-2.3-2.3-2.4-5.8-.3-7.9l6.2-6.2c1-1 2.4-1.6 3.9-1.5 1.5.1 2.9.7 3.9 1.8 2.3 2.3 2.4 5.8.3 7.9l-2.7 2.7s.1-1 0-1.9c-.1-.3-.1-.6-.4-1.5l1.3-1.3c1-1 .9-2.8-.3-4-.6-.6-1.4-1-2.2-1-.7 0-1.4.2-1.9.7L9.8 9.6c-1 1-.9 2.8.3 4l1 1.1-2 1.9-.9-1z", style: this.props.st0 }),
            _react2["default"].createElement("path", { className: "st0", d: "M15.6 8.3c2.3 2.3 2.4 5.8.3 7.9l-6.2 6.2c-1 1-2.4 1.6-3.9 1.5-1.5-.1-2.9-.7-3.9-1.8-2.3-2.3-2.4-5.8-.3-7.9l2.7-2.8s-.2.9-.1 1.9c.1.8.5 1.5.5 1.5l-1.3 1.3c-1 1-.9 2.8.3 4 .6.6 1.4 1 2.1 1 .7 0 1.4-.2 1.9-.7l6.2-6.2c1-1 .9-2.8-.3-4l-1-1.1 2-1.9 1 1.1z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/link.js